import classNames from 'classnames';
import PropTypes from 'prop-types';

import ChatSpacer from './ChatSpacer';

const MessageFrame = function MessageFrame({
  children = null,
  author,
  fullWidth,
  feedback,
  event,
  // Suppress the alignment spacer when the frame is not a direct child of a
  //  chat Row (e.g. reused inside the questionnaire interaction stack).
  noSpacer,
  className,
}) {
  return (
    <>
      <div
        className={classNames(
          'min-h-8 min-w-16 rounded-bl-2xl rounded-tr-2xl px-3 leading-5 py-2 order-3',
          {
            'rounded-tl-2xl': fullWidth || (!author),
            'rounded-br-2xl': fullWidth || author,
            'bg-msgMineBg text-msgMineTxt fill-msgMineTxt': (!author) && (!feedback) && (!event),
            'bg-msgOthersBg text-msgOthersTxt fill-msgOthersTxt': author && (!feedback) && (!event),
            'bg-msgEvent': event,
            'bg-pxUiOk': feedback,
            'flex-1': fullWidth,
          },
          className,
        )}
      >
        {children}
      </div>

      {(fullWidth || noSpacer)
        ? null
        : (
            <ChatSpacer
              author={author}
            />
          )}
    </>
  );
};

MessageFrame.propTypes = {
  children: PropTypes.node,
  author: PropTypes.string,
  fullWidth: PropTypes.bool,
  feedback: PropTypes.bool,
  event: PropTypes.bool,
  noSpacer: PropTypes.bool,
  className: PropTypes.string,
};

export default MessageFrame;
